module.exports = __webpack_public_path__ + "static/media/robotoi7.da0e7178.woff2";